import storage from '@react-native-async-storage/async-storage'; // defaults to localStorage for web and AsyncStorage for react-native
import {applyMiddleware, createStore} from 'redux';
import {persistReducer, persistStore} from 'redux-persist';
import thunk from 'redux-thunk';
import reducer from '../reducers';

// configuration for AsyncStorage persist: whitelist home and settings reducers
const persistConfig = {
  key: 'root',
  storage,
  whitelist: ['auth', 'home', 'general'],
};
const persistedReducer = persistReducer(persistConfig, reducer);

export const store = createStore(persistedReducer, applyMiddleware(thunk)); // use this for app

// export const store = createStore(composeWithDevTools(applyMiddleware(thunk))); // use this for TESTING

export const persistor = persistStore(store);
